import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { useTranslation } from "react-i18next"
import { toast } from "sonner"
import { getCustomerQueryKey } from "../lib/customerQuery"
import { getCustomersQueryKey } from "../lib/customersQuery"

type Props = {
  customerId: string
}

export function useOptOutCustomerMutation(props: Props) {
  const { t } = useTranslation()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async () => {
      await axios.patch(`/customers/${props.customerId}/opt-out`)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getCustomerQueryKey(props.customerId),
      })
      queryClient.invalidateQueries({ queryKey: getCustomersQueryKey() })
      toast.success(t("customers.profile.optOut.success"))
    },
  })
}
